import { ExchangeRateSourceType } from '@/app/constants/configuration/exchangeRateSourceType'
import { DATE_FORMAT } from 'app/constants/date'
import moment from 'moment'

export function getEmptyMessage(
  sourceType: ExchangeRateSourceType,
  t: (key: string) => string,
  exchangeRateDate: string,
) {
  switch (sourceType) {
    case ExchangeRateSourceType.QuarterWge:
      return t(
        'configuration.exchangeRates.no-exchange-rates-quarter-wge',
      ).replace('{0}', moment(exchangeRateDate).format(DATE_FORMAT))
    case ExchangeRateSourceType.Ecb:
      return t('configuration.exchangeRates.no-exchange-rates-ecb').replace(
        '{0}',
        ExchangeRateSourceType[sourceType],
      )
    case ExchangeRateSourceType.Nbp:
      return t('configuration.exchangeRates.no-exchange-rates-nbp').replace(
        '{0}',
        moment(exchangeRateDate).format(DATE_FORMAT),
      )
    default:
      return t('configuration.exchangeRates.no-exchange-rates-nbp')
        .replace('{0}', ExchangeRateSourceType[sourceType])
        .replace('{1}', moment(exchangeRateDate).format(DATE_FORMAT))
  }
}
